import { HTMLProps } from 'react'

export type MdAnchorProps = HTMLProps<HTMLAnchorElement>

export const MdAnchor = ({ children, ...rest }: MdAnchorProps) => {
  return <a {...rest}>{children}</a>
}
